import FadeTransition from "./Transition.Fade.vue";
import FadeUpTransition from "./Transition.FadeUp.vue";
import FadeScaleTransition from "./Transition.FadeScale.vue";
import MenuTransition from "./Transition.Menu.vue";
import ListItemTransition from "./Transition.ListItem.vue";

export const Transition =
{
    Fade: FadeTransition,
    FadeUp: FadeUpTransition,
    FadeScale: FadeScaleTransition,
    Menu: MenuTransition,
    ListItem: ListItemTransition
};